export default "__VITE_ASSET__IcuEsBMM__"